export default {"src":"/_next/static/media/reddit-logo.8cfc938b.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};